module.exports = __webpack_public_path__ + "img/dataset_compile.dbc2278a.png";